export enum BuyerTypeEnum {
    Store = 'Store',
    User = 'User',
  }
  
